'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadNotification = loadNotification;
exports.readOne = readOne;
exports.readAll = readAll;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* ===========================================
=            Notification Reducer            =
=========================================== */
var LOAD = 'lookme/notification/LOAD';
var LOAD_SUCCESS = 'lookme/notification/LOAD_SUCCESS';
var LOAD_FAIL = 'lookme/notification/LOAD_FAIL';
var READ_ONE = 'lookme/notification/READ_ONE';
var READ_ONE_SUCCESS = 'lookme/notification/READ_ONE_SUCCESS';
var READ_ONE_FAIL = 'lookme/notification/READ_ONE_FAIL';
var READ_ALL = 'lookme/notification/READ_ALL';
var READ_ALL_SUCCESS = 'lookme/notification/READ_ALL_SUCCESS';
var READ_ALL_FAIL = 'lookme/notification/READ_ALL_FAIL';

var initialState = {
  success: false,
  notifications: null,
  errors: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        success: false
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        success: true,
        notifications: action.result.notifications
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        success: false,
        notifications: null,
        error: action.error
      });
    case READ_ONE:
      return (0, _extends3.default)({}, state, {
        success: false
      });
    case READ_ONE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        success: true
      });
    case READ_ONE_FAIL:
      return (0, _extends3.default)({}, state, {
        success: false,
        errors: action.error
      });
    case READ_ALL:
      return (0, _extends3.default)({}, state, {
        success: false
      });
    case READ_ALL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        success: true
      });
    case READ_ALL_FAIL:
      return (0, _extends3.default)({}, state, {
        success: false,
        error: action.error
      });
    default:
      return state;
  }
}

/* ----------  actions  ---------- */

function loadNotification() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/notification/loadForUser');
    }
  };
}

function readOne(notificationID) {
  return {
    types: [READ_ONE, READ_ONE_SUCCESS, READ_ONE_FAIL],
    promise: function promise(client) {
      return client.post('/notification/read/' + notificationID);
    }
  };
}

function readAll() {
  return {
    types: [READ_ALL, READ_ALL_SUCCESS, READ_ALL_FAIL],
    promise: function promise(client) {
      return client.post('/notification/readAllForUser');
    }
  };
}
/* =====  End of Notification Reducer  ====== */


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/notification.js
// module id = 262
// module chunks = 0